import { IWorkflowLocationRestriction } from '~/client/graph'
import type { IWorkflowRestrictionDraft } from '~/client/src/shared/resources/domain/resourceControls'

// An empty workflowIds means the restriction applies to every type. Matches the
// wording the Workflow Types control cell uses for the same case.
function formatParts(value: string, workflowCount?: number): string {
  return `${value} max - ${workflowCount ? workflowCount : 'All'} Workflows`
}

export function formatWorkflowRestriction(
  restriction: IWorkflowLocationRestriction,
): string {
  return formatParts(
    String(restriction.values?.[0] ?? ''),
    restriction.workflowIds?.length,
  )
}

// Draft-shaped variant for staged (not-yet-persisted) restrictions, which lack
// the id/locationId/projectId fields IWorkflowLocationRestriction requires.
export function formatRestrictionDraft(
  draft: Pick<IWorkflowRestrictionDraft, 'values' | 'workflowIds'>,
): string {
  return formatParts(String(draft.values?.[0] ?? ''), draft.workflowIds?.length)
}
